<template>
  <div>
    <InertiaHead :title="$page.props.pageTitle" />
    <NotificationsContainer />
    <slot />
  </div>
</template>

<script setup>
import NotificationsContainer from '@/shared/components/NotificationsContainer.vue'
import { Head as InertiaHead } from '@inertiajs/vue3'
import { useCrispChatInitializer } from '@/shared/composables/useCrispChatInitializer.js'
import { useRecaptchaProvider } from 'vue-recaptcha/head'

useRecaptchaProvider()
useCrispChatInitializer()
</script>

<script>
export default {
  name: 'AuthLayout',
  meta: {
    bodyClass: 'tw-bg-white',
  },
}
</script>
